import { render, staticRenderFns } from "./add-organize.vue?vue&type=template&id=eac1217e&scoped=true"
import script from "./add-organize.vue?vue&type=script&lang=ts"
export * from "./add-organize.vue?vue&type=script&lang=ts"
import style0 from "./add-organize.vue?vue&type=style&index=0&id=eac1217e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac1217e",
  null
  
)

export default component.exports